
/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Module for export to Excel

Author: Deimos Space UK

Version: 1.0
*/

import { saveAs } from "file-saver";
import ExcelJS from "exceljs";


export const saveFile = (excelData, name) => {
  excelData.xlsx.writeBuffer().then((buffer) => {
    saveAs(new Blob([buffer], { type: "application/octet-stream" }), `${name}.xlsx`)
  })
}

export const rawDataIntoExcel = (data, name) => {
  const ExcelJSWorkbook = new ExcelJS.Workbook();
  const worksheet = ExcelJSWorkbook.addWorksheet(name);
  const headerRow = worksheet.addRow();
  const headers = Object.keys(data[0]);

  headers.forEach((header, index) => {
    let cell = headerRow.getCell(index + 1);
    worksheet.getColumn(index + 1).width = 30
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '00003247' } };

    cell.value = header;
    cell.font = { bold: true, size: 12 , color: { argb: 'FFFFFF' }};
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  });


  data.forEach((row) => {
    const dataEow = worksheet.addRow();
    headers.forEach((header, index) => {
      let cell = dataEow.getCell(index + 1);
      cell.value = row[header];
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
  });

  return ExcelJSWorkbook;
};

